/** @jsx jsx */
import { jsx, Box, Image } from "theme-ui";
import Avatar from "gatsby-plugin-hfn-profile/auth/Avatar";
import SignInButton from "gatsby-plugin-hfn-profile/auth/SignInButton";
import { navigate } from "@reach/router";
import PropTypes from "prop-types";
import Logo from "../../assets/hfncare-logo.png";

const goHome = () => navigate("/");

const Header = ({ title }) => {
  return (
    <Box>
      <div>
        <table
          sx={{
            width: "100%",
            opacity: 1,
            py: 3,
            backgroundColor: "#ffffff",
            boxShadow: "0px 3px 6px #00000029",
          }}
        >
          <tbody>
            <tr>
              <td>
                <Box>
                  {title || (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Image
                        width="80"
                        src={Logo}
                        alt="Heartfulness"
                        sx={{ cursor: "pointer", px: 3 }}
                        role="button"
                        tabIndex={0}
                        onClick={goHome}
                        onKeyDown={goHome}
                      />
                    </Box>
                  )}
                </Box>
              </td>
              <td align="right">
                <Box sx={{ px: 3 }}>
                  <Avatar />
                  <SignInButton btnText="Sign-In" />
                </Box>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Box>
  );
};

Header.propTypes = {
  title: PropTypes.oneOf([PropTypes.element, PropTypes.string]),
};

Header.defaultProps = {
  title: null,
};

export default Header;
